import {Component, Input, OnInit} from '@angular/core';
import {MenuItemInventory} from '../../_models/menu-item-inventory';
import {BaseModalComponent} from '../base-modal.component';
import {ModalController} from '@ionic/angular';
import {LoadingService} from '../../_services/loading.service';
import {MenuItemInventoryActionService} from '../../_services/menu-item-inventory-action.service';
import {MenuItemInventoryService} from '../../_services/menu-item-inventory.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'bb-kick-keg',
    templateUrl: './kick-keg.component.html',
    styleUrls: ['./kick-keg.component.scss'],
})
export class KickKegComponent extends BaseModalComponent implements OnInit {
    @Input() menuItemInventory: MenuItemInventory;
    @Input() backOfHouseInventory: MenuItemInventory;

    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private menuItemInventoryActionService: MenuItemInventoryActionService,
        private menuItemInventoryService: MenuItemInventoryService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            containerQuantity: [!!this.menuItemInventory ? this.menuItemInventory.containerQuantity : null, Validators.required]
        });
    }

    kickOnly() {
        this.loadingService.present();
        this.menuItemInventoryActionService.kick(this.menuItemInventory.id).subscribe(m => {
            if (!!m) {
                this.menuItemInventoryService.setEvent(new MenuItemInventory(m));
            }
            this.loadingService.dismiss();
            this.close();
        });
    }

    kickAndReplace() {
        this.loadingService.present();
        this.menuItemInventoryActionService.kickAndReplace(this.menuItemInventory.id, this.formGroup.controls.containerQuantity.value)
            .subscribe(m => {
                if (!!m) {
                    this.menuItemInventoryService.setEvent(new MenuItemInventory(m));
                }
                this.loadingService.dismiss();
                this.close();
            });
    }
}
